import DashboardStore from './DashboardStore'

export default DashboardStore
